import { apiAddress } from '../ApiPlatform';

export const API_INSERT_COMP = apiAddress + '/work/insertComp';
export const API_UPDATE_COMP = apiAddress + '/work/updateComp';
export const API_SELECT_COMP_LIST = apiAddress + '/work/selectCompList';
